import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import EmailIcon from '@mui/icons-material/Email';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import { IconButton, Tooltip } from '@mui/material';
import Snackbar from '@mui/material/Snackbar';
import classNames from 'classnames';
import { useState } from 'react';
import createTheme from '/@/components/theme-provider';
import settings from '/@/core/settings';
import { _ } from '/@/locale';
import { isMobile, openWhatsappWeb } from '/@/utils';
import colors from '../theme-provider/colors';
import styles from './styles.module.css';

const ShareButtons = ({ className, message, handleEmail, handleDownload, handleCopy }) => {
    const [showSnack, setShowSnack] = useState(false);

    const handleWhatsapp = () => {
        const encodedMessage = encodeURIComponent(message);
        if (isMobile()) window.location.href = `whatsapp://send?text=${encodedMessage}`;
        else openWhatsappWeb({ message });
    };

    const handleCopyAndShowSnack = () => {
        handleCopy();
        if (!showSnack) {
            setShowSnack(true);
        }
    };

    const theme = createTheme({ app: settings.app.theme }); // Use our exten

    return (
        <div className={classNames(styles.root, className)}>
            {handleCopy && (
                <Tooltip arrow title={_('Copiar perfil')}>
                    <IconButton
                        sx={{
                            p: 0,
                            background: (t) => t.palette.primary.main,
                            ':hover': {
                                background: (t) => t.palette.primary[600],
                            },
                            color: 'white !important',
                            width: 35,
                            height: 35,
                        }}
                        onClick={handleCopyAndShowSnack}
                    >
                        <ContentCopyIcon sx={{ color: 'white' }} />
                    </IconButton>
                </Tooltip>
            )}

            {message && (
                <Tooltip arrow title={_('Compartir por Whatsapp')}>
                    <IconButton
                        sx={{
                            p: 0,
                            color: 'white !important',
                            background: colors.success[200],
                            ':hover': { background: '#23d366' },
                            width: 35,
                            height: 35,
                        }}
                        onClick={handleWhatsapp}
                    >
                        <WhatsAppIcon />
                    </IconButton>
                </Tooltip>
            )}

            {handleEmail && (
                <IconButton
                    sx={{
                        p: 0,
                        color: 'white !important',
                        background: (t) => t.palette.primary.main,
                        ':hover': {
                            background: (t) => t.palette.primary[300],
                        },
                        width: 35,
                        height: 35,
                    }}
                    onClick={handleEmail}
                >
                    <EmailIcon />
                </IconButton>
            )}

            {handleDownload && (
                <IconButton
                    sx={{
                        p: 0,
                        color: 'white !important',
                        background: colors.gray.default,
                        ':hover': {
                            background: colors.gray[800],
                        },
                        width: 35,
                        height: 35,
                    }}
                    onClick={handleDownload}
                >
                    <FileDownloadIcon />
                </IconButton>
            )}

            <Snackbar
                theme={theme}
                open={showSnack}
                autoHideDuration={2000}
                message={_('Copiado exitosamente!')}
                onClose={() => setShowSnack(false)}
            />
        </div>
    );
};

export default ShareButtons;
